export default function Footer() {
  const year = 2020;
  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="w-full px-6 md:px-10 lg:px-14 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 gap-10">
          <div className="sm:col-span-2 md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="https://storage.helloreaddy.io/project_files/6a6310ba-0547-4942-a5e0-6c602507315a/4ff0e6c9-817e-4060-8942-21370fe415ed_compressed_t.webp"
                alt="CCF DAIRY"
                className="h-10 w-auto object-contain"
              />
              <span
                className="text-lg md:text-xl font-heading font-medium tracking-tight text-background-50 leading-tight"
                style={{ fontFamily: "Fraunces, serif" }}
              >
                Co-Creation Farm
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-200/85 max-w-md">
              CCF is a leading online dairy farming platform. We believe great farming needs great collaboration — premium global farms × diversified strategy × stable returns — that's our commitment to every member.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="text-sm font-semibold text-background-50 tracking-wide">
              Platform
            </div>
            <ul className="mt-4 space-y-3 text-sm">
              {[
                { label: "About CCF", href: "#about" },
                { label: "Advantages", href: "#advantage" },
                { label: "How It Works", href: "#how" },
              ].map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-background-200/85 hover:text-background-50 cursor-pointer"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-sm font-semibold text-background-50 tracking-wide">
              Community
            </div>
            <ul className="mt-4 space-y-3 text-sm">
              {["Partner Farms", "Member Stories", "Farm Visit Days"].map((l) => (
                <li key={l}>
                  <a
                    href="#farms"
                    className="text-background-200/85 hover:text-background-50 cursor-pointer"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-sm font-semibold text-background-50 tracking-wide">
              Contact
            </div>
            <ul className="mt-4 space-y-3 text-sm text-background-200/85">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-accent-400 mt-0.5"></i>
                cocreationfarm@gmail.com
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-accent-400 mt-0.5"></i>
                5445 DTC Pkwy, Greenwood Village, CO 80111
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-background-50/10 flex justify-center">
          <div className="text-xs text-background-200/70 text-center">
            © {year} CCF Co-Creation Farm. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}